export const testimonials = [
  {
    id: 1,
    name: "James Whitfield",
    company: "Whitfield Tea Imports",
    location: "London, United Kingdom",
    rating: 5,
    text: "Pandit Export has been our go-to supplier for Dooars and Assam Tea for over a year now. The quality is absolutely outstanding — the aroma and liquor are exactly what our premium customers expect. Dhrubajit and his team are professional, responsive, and always deliver on time. Highly recommended!"
  },
  {
    id: 2,
    name: "Ahmed Al-Rashid",
    company: "Al-Rashid Spice Trading",
    location: "Dubai, UAE",
    rating: 5,
    text: "We've been importing Lakadong Turmeric and Indian spices from Pandit Export for our herbal product line. The curcumin content in their Lakadong Turmeric is genuinely among the highest we've tested — completely authentic. The packaging is export-grade, documentation is perfect, and communication is always transparent."
  },
  {
    id: 3,
    name: "Sophie Laurent",
    company: "Herbes Naturelles SARL",
    location: "Paris, France",
    rating: 5,
    text: "Finding a reliable Indian exporter was challenging until we discovered Pandit Export. Their White Turmeric is of exceptional quality and highly sought after by our pharmacy clients. The minimum order quantities are flexible and the entire process from order to delivery is smooth and professional. A true global supply partner!"
  }
];
